<template>
  <v-app>
    <router-view></router-view>
    <v-dialog v-model="loading" fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState("app", {
      loading: state => state.loading
    }),
    ...mapGetters("auth", ["isAuthenticated"])
  },
  watch: {
    isAuthenticated: function() {
      this.goToLogin();
    }
  },
  mounted: function() {
    this.initialize();
  },
  methods: {
    goToLogin() {
      if (this.isAuthenticated == false && this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    },
    initialize() {
      this.goToLogin();
      //this.$store.dispatch("services/getApiList");
      //this.$store.dispatch("services/getServiceTypes");
    }
  }
};
</script>